import React, { useState } from 'react';
import { ArrowLeft, Users, Mail, Lock } from 'lucide-react';
import { Button } from './ui/button';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      alert('Please fill in all fields');
      return;
    }
    
    setIsLoading(true);
    
    try {
      const response = await axios.post(`${API_BASE}/api/community/login`, {
        email,
        password
      });
      
      if (response.data.message === 'Login successful') {
        // Store user info in localStorage for persistence
        localStorage.setItem('currentUser', JSON.stringify(response.data.user));
        
        alert('Login successful! Redirecting to community...');
        navigate('/community');
      }
    } catch (error) {
      console.error('Login failed:', error);
      alert(error.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="dark-container min-h-screen" style={{ paddingTop: '100px' }}>
      <div className="max-w-md mx-auto px-6 py-8">
        <Link to="/community">
          <Button className="btn-secondary mb-8">
            <ArrowLeft size={20} />
            Back to Community
          </Button>
        </Link>

        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-turquoise-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Users size={40} className="text-turquoise-400" />
          </div>
          <h1 className="display-large mb-4">
            Sign In to <span className="turquoise-text-gradient">Community</span>
          </h1>
          <p className="body-large text-gray-300">
            Welcome back! Connect with fellow consultants and share insights.
          </p>
        </div>

        <form onSubmit={handleLogin} className="bg-gray-900/50 border border-turquoise-500/20 rounded-16 p-6 mb-6">
          <div className="space-y-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                <Mail size={16} className="inline mr-2" />
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full p-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:border-turquoise-400 focus:outline-none transition-colors"
                placeholder="Enter your email"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                <Lock size={16} className="inline mr-2" />
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full p-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:border-turquoise-400 focus:outline-none transition-colors"
                placeholder="Enter your password"
              />
            </div>
          </div>
          
          <Button 
            type="submit" 
            className="btn-primary-enhanced w-full"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                Signing In...
              </>
            ) : (
              <>
                <Users size={20} />
                Sign In
              </>
            )}
          </Button>
        </form>

        <div className="text-center space-y-4">
          <Link to="/forgot-password" className="block">
            <Button className="btn-secondary w-full">
              Forgot Password?
            </Button>
          </Link>
          
          <div>
            <p className="text-gray-400 mb-4">Don't have an account yet?</p>
            <Link to="/signup">
              <Button className="btn-primary-enhanced w-full">
                Create New Account
              </Button>
            </Link>
          </div>
        </div>

        <div className="mt-8 p-4 bg-turquoise-500/10 border border-turquoise-500/20 rounded-lg">
          <h3 className="text-turquoise-400 font-medium mb-2">Join ShansoConsult Community</h3>
          <p className="text-gray-400 text-sm">
            Connect with business excellence professionals, share insights, and access exclusive training materials.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;